import React from "react";
import { useStressEntryContext } from "./StressEntryContext";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import { ErrorMessage } from "../../../common/ErrorMessage";

import {
  Grid,
  LinearProgress,
  Paper,
  TextField,
  useTheme,
} from "@material-ui/core";

import { useStressProcedures } from "./stressEntryQueries";
import {
  STRESSOR_CHECK_IN_MODE,
  STRESSOR_CHECK_OUT_MODE,
  STRESSOR_CHECK_PAUSE_MODE,
} from "./constants";
import { Autocomplete } from "@material-ui/lab";
import { useSelectedProcedure } from "../../../dataEgress/dataEgressMutations";
import { toast } from "react-toastify";
import { useFetchContext } from "../../../common/FetchContext";

export const ProcedureSelector = () => {
  const theme = useTheme();
  const { state, dispatch } = useStressEntryContext();

  const { authAxios } = useFetchContext();

  const {
    mutateAsync: mutateProcedure,
    error: errorProcedureSelected,
    isError: isErrorMutateProcedureSelected,
    isSuccess: isSuccessProcedureSelected,
    isLoading: isLoadingTransisLog,
  } = useSelectedProcedure();
  const { data, error, isLoading, isError } = useStressProcedures(
    state?.selectedStressType?.id,
    state.mode,
  );

  if (!state.selectedStressType) {
    return null;
  }

  if (isLoading) {
    return <LinearProgress />;
  }

  if (isError) {
    return <ErrorMessage error={error} />;
  }

  const listProcedures = [
    "damp_heat",
    "thermal_cycling",
    "CID_TEST",
    "LETID_TEST",
    "light_soak",
    "PIDTest",
    "HailTest",
    "UVIDTest",
    "HumidityFreezeTest",
    "DML",
    "SML",
  ];

  const handleSelection = (selectedStressProcedure: any) => async () => {
    const selectedProcedureId = selectedStressProcedure.id;

    try {
      var data = await mutateProcedure({
        authAxios,
        procedure_definition_id: selectedProcedureId,
      });
      console.log("data", data.test_type);
      switch (data.test_type) {
        case listProcedures[0]:
          dispatch({ type: "SET_IS_DAMP_HEAT_CHECK", payload: true });
          break;
        case listProcedures[1]:
          dispatch({ type: "SET_IS_THERMAL_CYCLING_CHECK", payload: true });
          break;
        case listProcedures[2]:
          dispatch({ type: "SET_IS_CID_TEST_CHECK", payload: true });
          break;
        case listProcedures[3]:
          dispatch({ type: "SET_IS_LETID_TEST_CHECK", payload: true });
          break;
        case listProcedures[4]:
          dispatch({ type: "SET_IS_LIGHT_SOAK_CHECK", payload: true });
          break;

        case listProcedures[5]:
          dispatch({ type: "SET_IS_PID_CHECK", payload: true });
          break;

        case listProcedures[6]:
          dispatch({ type: "SET_IS_HAIL_CHECK", payload: true });
          break;

        case listProcedures[7]:
          dispatch({ type: "SET_IS_UVID_CHECK", payload: true });
          break;

        case listProcedures[8]:
          dispatch({ type: "SET_IS_HUMIDITY_CHECK", payload: true });
          break;
        case listProcedures[9]:
          dispatch({ type: "SET_IS_DML_CHECK", payload: true });
          break;
        case listProcedures[10]:
          dispatch({ type: "SET_IS_SML_CHECK", payload: true });
          break;
        default:
          break;
      }
    } catch (err) {
      toast.error("No data found");
    }

    if (
      state.selectedStressProcedure &&
      selectedStressProcedure.id !== state.selectedStressProcedure.id
    ) {
      dispatch({ type: "CLEAN_SCANNED_UNITS" });
    }
    dispatch({
      type: "SET_SELECTED_STRESS_PROCEDURE",
      payload: { selectedStressProcedure },
    });
  };

  return (
    <div style={theme.container}>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        spacing={2}
      >
        <Grid item xs={6}>
          {state.mode === STRESSOR_CHECK_IN_MODE && (
            <FormControl
              style={{
                minWidth: 200,
              }}
            >
              {/* <InputLabel id="demo-simple-select-helper-label">
                Select a procedure
              </InputLabel>
              <Select
                variant="filled"
                defaultValue={0}
                value={
                  state.selectedStressProcedure?.id
                    ? state.selectedStressProcedure.id
                    : 0
                }
              >
                <MenuItem value={0}>
                  <em>None</em>
                </MenuItem>
                {data.map((stressProcedure: any) => (
                  <MenuItem
                    value={stressProcedure.id}
                    onClick={handleSelection(stressProcedure)}
                  >
                    {stressProcedure.name}
                  </MenuItem>
                ))}
              </Select> */}
              <Autocomplete
                options={data}
                getOptionLabel={(option: any) => option.name || ""}
                value={state.selectedStressProcedure || null}
                getOptionSelected={(option, value) => option.id === value.id}
                onChange={(event, stressProcedure) => {
                  if (!stressProcedure) return;
                  handleSelection(stressProcedure)();
                }}
                PaperComponent={(props) => (
                  <Paper {...props} style={{ width: 250 }} />
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select a procedure"
                    variant="filled"
                  />
                )}
              />
            </FormControl>
          )}
        </Grid>
      </Grid>
    </div>
  );
};
